module.exports = __webpack_public_path__ + "static/media/omega3.3524e745.svg";